/**
 * Adapter payload(schemaVersion=1) -> Chart.js 2.x config (horizontalBar datasets).
 */
export function payloadToHorizontalGroupedBarChartjs(payload) {
  const p = payload || {}
  const categories = Array.isArray(p.categories) ? p.categories : []
  const series = Array.isArray(p.series) ? p.series : []
  const values = p.values && typeof p.values === 'object' ? p.values : {}

  const labels = categories.map((c) => c?.label ?? '')
  const categoryKeys = categories.map((c) => c?.key ?? '')

  const orderedSeries = [...series].sort((a, b) => Number(a?.order ?? 0) - Number(b?.order ?? 0))
  const datasets = orderedSeries.map((s) => {
    const key = String(s?.key ?? '')
    const row = values?.[key] || {}
    const data = categoryKeys.map((ck) => {
      const v = Number(row?.[ck] ?? 0)
      // Em Chart.js 2.x, null/undefined faz o bar não ser desenhado.
      // Isso evita “marcador” visual em meses vazios (valor 0).
      return v === 0 ? null : v
    })
    return {
      label: String(s?.label ?? key),
      backgroundColor: String(s?.color ?? '#2563eb'),
      borderColor: String(s?.color ?? '#2563eb'),
      borderWidth: 1,
      data,
    }
  })

  const axis = p.options?.valueAxis || {}
  const min = axis.min != null ? Number(axis.min) : 0
  const max = axis.max != null ? Number(axis.max) : undefined
  const step = axis.step != null ? Number(axis.step) : undefined

  return {
    data: { labels, datasets },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      legend: { display: true, position: 'bottom', labels: { boxWidth: 12, padding: 12 } },
      plugins: {
        // O projeto registra chartjs-plugin-datalabels globalmente (src/main.js).
        // Para esse gráfico, não queremos números sobre as barras.
        datalabels: { display: false },
      },
      scales: {
        xAxes: [
          {
            ticks: {
              beginAtZero: true,
              min,
              ...(Number.isFinite(max) ? { max } : {}),
              ...(Number.isFinite(step) ? { stepSize: step } : {}),
            },
            gridLines: { display: true },
          },
        ],
        yAxes: [{ gridLines: { display: false } }],
      },
    },
  }
}

